import React from 'react';
import { ButtonProps } from 'antd/lib/button';
import Svg from '@svg/index';
import Tooltip from '@ui-library/tooltip';
import { Flex } from '@ui-library/misc';
import {
  Primary,
  Secondary,
  DeletePrimary,
  DeleteOutlined,
  TextPrimary,
  TextSecondary,
  TextDelete,
} from './styles';

interface OwnProps {
  secondary?: boolean;
  deletePrimary?: boolean;
  deleteOutlined?: boolean;
  textPrimary?: boolean;
  textSecondary?: boolean;
  textDelete?: boolean;
  svg?: {
    name: string;
    align?: 'start';
  };
  name?: string;
  children?: React.ReactNode | React.ReactNode[];
  height?: 'l';
  tooltip?: string;
  tooltipPlacement?: 'left';
  'data-testid'?: string;
}

type Props = ButtonProps & OwnProps;

const child = (props: Props) => {
  if (props?.svg) {
    return (
      <>
        {props?.svg && props?.svg.align === 'start' ? (
          <Flex flexDirection="row" justifyContent="start" alignItemsCenter>
            <Svg name={props?.svg.name} />
            <div className="m-l-sm">{props?.children}</div>
          </Flex>
        ) : (
          <>
            <div className="m-r-sm">{props?.children}</div>
            <Svg name={props?.svg && props?.svg.name ? props?.svg.name : ''} />
          </>
        )}
      </>
    );
  }

  if (props?.name) {
    return props.name;
  }

  return <>{props?.children}</>;
};

export default (props: Props) => {
  const comp = (() => {
    const {
      secondary,
      deletePrimary,
      deleteOutlined,
      textPrimary,
      textSecondary,
      textDelete,
      ...others
    } = props;
    if (secondary) {
      return <Secondary {...others}>{child(props)}</Secondary>;
    }

    if (deletePrimary) {
      return <DeletePrimary {...others}>{child(props)}</DeletePrimary>;
    }

    if (deleteOutlined) {
      return <DeleteOutlined {...others}>{child(props)}</DeleteOutlined>;
    }

    if (textPrimary) {
      return <TextPrimary {...others}>{child(props)}</TextPrimary>;
    }

    if (textSecondary) {
      return <TextSecondary {...others}>{child(props)}</TextSecondary>;
    }

    if (textDelete) {
      return <TextDelete {...others}>{child(props)}</TextDelete>;
    }

    return <Primary {...others}>{child(props)}</Primary>;
  })();

  if (props?.tooltip && props?.tooltip.length > 0 && props.disabled) {
    return (
      <Tooltip title={props.tooltip} placement={props.tooltipPlacement || 'top'}>
        {comp}
      </Tooltip>
    );
  }

  return comp;
};
